import React, {useEffect, useState} from 'react';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import ExtractForm from "../../../components/data_products/extracts/ExtractForm";
import {useAdminBucket} from "../../../components/utils";
import {
  useCreateDataVendorExtractMutation,
  useGetDataVendorExtractAggregationOptionsQuery
} from '../../../api/dataVendorExtractApiSlice';
import {useGetDataVendorAudiencesQuery} from "../../../api/dataVendorAudienceApiSlice";


export default function NewDataVendorExtract(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { dataVendorKey } = useParams();
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const bucket = useAdminBucket(dataVendorKey)
  const { data: aggregationOptions = [] } = useGetDataVendorExtractAggregationOptionsQuery(dataVendorKey)
  const { data: audiences = [] } = useGetDataVendorAudiencesQuery(dataVendorKey)

  const handleBack = () => history.push({
    pathname: `/data_vendors/${dataVendorKey}`,
    state: {activeTab: 'extracts'}
  });

  const goToExtract = (data) => history.push(`/data_vendors/${dataVendorKey}/extracts/${data.key}`)

  const [createExtract] = useCreateDataVendorExtractMutation()
  const submitProps = {
    handleSubmit: (data) => {
      createExtract({...data, dataVendorId: dataVendorKey}).unwrap()
        .then(goToExtract)
        .catch(error => {})
    },
    errors: {}
  }

  return (
    <>
      <Title
        main={t("menu.extracts")}
        sub={t("new")}
        group={false}
        onBack={handleBack}>
        <FormButton submit {...submitButtonProps}/>
      </Title>
      <ExtractForm
        bucket={bucket}
        {...submitProps}
        setSubmitButtonProps={setSubmitButtonProps}
        aggregationOptions={aggregationOptions}
        audiences={audiences}
      />
    </>
  )
}

